import { useEffect } from "react";
export default function scrollIntoView(element, parent, horizontal = false) {
    if (!element || !parent || !element.parentElement)
        return;
    const offsetProp = horizontal ? "offsetLeft" : "offsetTop";
    const scrollProp = horizontal ? "scrollLeft" : "scrollTop";
    const sizeProp = horizontal ? "clientWidth" : "clientHeight";
    const offset = (element.parentElement === parent ? 0 : element.parentElement[offsetProp]) + element[offsetProp];
    if (parent[scrollProp] + parent[sizeProp] < offset + element[sizeProp]) {
        parent[scrollProp] = offset + element[sizeProp] - parent[sizeProp];
    }
    else if (parent[scrollProp] > offset) {
        parent[scrollProp] = offset;
    }
}
export function useScrollIntoView(scrollToView, ref, horizontal = false) {
    useEffect(() => {
        var _a;
        if (scrollToView && ref.current) {
            const parent = (typeof scrollToView === "boolean" ? (_a = ref.current) === null || _a === void 0 ? void 0 : _a.parentElement : scrollToView(ref.current)) || null;
            requestAnimationFrame(() => scrollIntoView(ref.current, parent, horizontal));
        }
    }, [horizontal, ref, scrollToView]);
}
//# sourceMappingURL=scroll-into-view.js.map